import button from './../../css/button';

export default {
    props: {
        preventDefault: {
            type: Boolean,
            default: false
        },
        disabled: {
            type: Boolean,
            default: false
        },
        loading: {
            type: Boolean,
            default: false
        },
        small: {
            type: Boolean,
            default: false
        },
        xSmall: {
            type: Boolean,
            default: false
        },
        extraClass: {
            type: String,
            default: ''
        },
        color: {
            type: String,
            default() {
                return button.color.default;
            }
        },
        fontSize: {
            type: String,
            default() {
                return button.fontSize.default;
            }
        },
        className: {
            type: String,
            default: null
        },
    },

    data() {
        return {
            submitted: false
        }
    },

    computed: {
        buttonClassName() {
            if ( this.className ) {
                return this.className;
            }

            let padding = button.padding.normal;
            if ( this.small ) {
                padding = button.padding.sm;
            }
            if ( this.xSmall ) {
                padding = button.padding.xs;
            }

            let color = this.color;
            if ( this.disabled ) {
                color = button.color.disabled;
            }

            return padding + ' ' + color + ' ' + this.extraClass + ' ' + this.fontSize + ' ' + button.base;
        }
    },

    methods: {
        load() {
            this.submitted = true;
        },

        stop() {
            this.submitted = false;
        },
        
        clicked(event) {
            if ( this.disabled ) {
                return;
            }

            this.$emit('clicked', event);
            if ( this.preventDefault && event ) {
                event.preventDefault();
            }
        }
    }
}